var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"linkedinicon","viewBox":"0 0 23 23"},[React.createElement("rect",{"style":{"fill":"#0076B4"},"width":"23","height":"23","key":0}),React.createElement("path",{"className":"iwh","d":"M6.6,19H3.3V8.3h3.3V19z M4.9,6.9C3.9,6.9,3,6,3,4.9C3,3.9,3.9,3,4.9,3C6,3,6.8,3.9,6.8,4.9     C6.8,6,6,6.9,4.9,6.9z M19,19h-3.3v-5.2c0-1.2,0-2.8-1.7-2.8c-1.7,0-2,1.4-2,2.7V19H8.7V8.3h3.2v1.5h0C12.3,8.9,13.4,8,15,8     c3.4,0,4,2.2,4,5.1V19z","key":1})]));
}

Linkedin.defaultProps = {};

module.exports = Linkedin;

Linkedin.default = Linkedin;
